import Payment from './payment';

$(() => {
    Payment.checkRoute();
    Payment.handleServerResponse();
    Payment.bindSubmit();
});
